import { render } from "./BoxIcon.vue?vue&type=template&id=4bef548a&ts=true"
import script from "./BoxIcon.vue?vue&type=script&lang=ts"
export * from "./BoxIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__